/* global axios */
import ApiClient from './ApiClient';

class LeadScoreRulesAPI extends ApiClient {
  constructor() {
    super('lead_score_rules', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { lead_score_rule: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { lead_score_rule: data });
  }

  createDefaults() {
    return axios.post(`${this.url}/create_defaults`);
  }
}

export default new LeadScoreRulesAPI();
